export default __webpack_public_path__ + "static/media/4.9538d3af.webp";